module.exports = __webpack_public_path__ + "static/media/logo.889e7a7a.svg";